import { DatePipe } from '@angular/common';
import {
	OnInit,
	Component,
	OnDestroy,
	ChangeDetectionStrategy,
} from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { Subscription } from 'rxjs';
import { CustomTableComponent } from '../../../../custom-table/custom-table.component';

@Component({
	selector: 'app-multiple-status-code',
	templateUrl: './multiple-status-code.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./multiple-status-code.component.scss'],
	imports: [CustomTableComponent],
})
export class MultipleStatusCodeComponent implements OnInit, OnDestroy {
	constructor(
		private apiService: LegacyApiService,
		private datepipe: DatePipe
	) {
		this.columnDefs = [
			{ headerName: 'Loan Number', field: 'loan_number', width: 10 },
			{ headerName: 'Status Code', field: 'status_code', width: 200 },
		];

		this.defaultExcelExportParams = {
			fileName: `multiple_status_code_${this.datepipe.transform(new Date(), 'yyyy-MM-dd')}.xlsx`,
		};
		this.defaultCsvExportParams = {
			fileName: `multiple_status_code_${this.datepipe.transform(new Date(), 'yyyy-MM-dd')}.csv`,
		};
	}

	private collectionsDataSubscription: Subscription;

	protected showLoader: boolean;
	protected columnDefs = [];
	protected rowData;
	protected defaultExcelExportParams;
	protected defaultCsvExportParams;

	ngOnInit(): void {
		this.getDuplicateStatusCode();
	}

	ngOnDestroy() {
		this.collectionsDataSubscription?.unsubscribe();
	}

	getDuplicateStatusCode() {
		this.showLoader = true;
		this.collectionsDataSubscription = this.apiService
			.getMultipleStatusCode()
			.subscribe((res) => {
				this.rowData = res;
				this.showLoader = false;
			});
	}
}
